import { Firebase } from "@/app/core/base/FirebaseApp";
import { toast } from "react-toastify";
import {
  getFirestore,
  collection,
  getDocs,
  updateDoc,
  doc,
  getDoc,
  Timestamp,
  getCountFromServer,
  query,
  where,
  addDoc,
  deleteDoc,
  setDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

export const ServicesController = {
  auth: getAuth(Firebase),
  db: getFirestore(Firebase),

  List: async function ({ status }) {
    console.log("Status",status);
    let servicesQuery = collection(this.db, "services");
    if (status) {
      servicesQuery = query(
        collection(this.db, "services"),
        where("status", "==", status)
      );
    }
    const servicesSnapshot = await getDocs(servicesQuery);
    return servicesSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  },

  ListAll: async function () {
    let servicesQuery = collection(this.db, "services");
    const servicesSnapshot = await getDocs(servicesQuery);
    return servicesSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  },

  ListSelectedServices: async function (selectedServices) {
    const servicesQuery = query(
      collection(this.db, "services"),
      where("id", "in", selectedServices)
    );
    const servicesSnapshot = await getDocs(servicesQuery);
    return servicesSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  },

  Add: async function (service) {
    const servicesCollection = collection(this.db, "services");
    await addDoc(servicesCollection, service);
  },

  Update: async function (service) {
    const serviceDoc = doc(this.db, "services", service.id);
    await updateDoc(serviceDoc, service);
  },

  Delete: async function (serviceId) {
    const serviceDoc = doc(this.db, "services", serviceId);
    await deleteDoc(serviceDoc);
  },
};
